import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import '@/components/redesign/SolarPublic.css';
import '@/components/redesign/PublicReadability.css';
import '@/components/redesign/PublicContrast.css';
import '@/components/redesign/CustomerContent.css';
import '@/components/redesign/CustomerService.css';
import '@/components/seo/CustomerSEO.css';
import '@/components/evRedesign/Editorial.css';
import '@/components/evRedesign/Journey.css';
import '@/components/evRedesign/ProductPages.css';
import '@/components/redesign/PublicCopy.css';
const INTERNAL = ['/admin', '/internalanalytics', '/cs-dashboard', '/dealbuilder-internal', '/tprs', '/media-creator', '/affiliate', '/upload', '/seogenerator', '/surveyadmin', '/opladereadmin', '/aiassistantadmin', '/henvisningadmin', '/appsurveyadmin', '/opladere/admin'];
export default function PublicThemeFrame({ children }) {
  const { pathname } = useLocation();
  const path = pathname.toLowerCase();
  const internal = INTERNAL.some(prefix => path === prefix || path.startsWith(prefix + '/'));
  const excluded = internal || /^\/(blog|articles|en\/blog)/.test(path) || ['/elbilejeres-guldaeg', '/kundeportal', '/en/customer-portal'].includes(path);
  useEffect(() => {
    if (!excluded) document.body.dataset.evJourney = 'true';
    else delete document.body.dataset.evJourney;
    return () => { delete document.body.dataset.evJourney; };
  }, [excluded]);
  return <div className={internal ? undefined : `solar-public${excluded ? '' : ' ev-journey'}`}>{children}</div>;
}